<template>
  <div class="content">
    <div class="top">
      <div class="el-steps-box">
        <el-steps :active="1" finish-status="success" simple>
          <el-step :title=ApplicationSelection></el-step>
          <el-step :title=AppLoadconditions></el-step>
          <el-step :title=ReducerLoadconditions></el-step>
          <el-step :title=reducerSize></el-step>
          <el-step :title=selectMotor></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <!-- 内容页 -->
    <div class="appPic">
      <img src="../../../../static/appPic/app04.png" alt="">
    </div>
    <h3 class="appPic_title">{{$t('message.shengjiang_1')}}</h3>
    <el-tabs class="app_item" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane :label=loadCondition name="first">
        <el-form ref="form" :rules="rules" :model="form" label-width="150px" class="app_item_form">
          <el-form-item :label=shengjiang_2 prop="m1">
            <span class="first_span">m1</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.m1" auto-complete="off"></el-input>
            <span>(kg)</span>
          </el-form-item>
          <el-form-item :label=shengjiang_3 prop="m2">
            <span class="first_span">m2</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.m2" auto-complete="off"></el-input>
            <span>(kg)</span>
          </el-form-item>
          <el-form-item :label=shengjiang_4 prop="m3">
            <span class="first_span">m3</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.m3" auto-complete="off"></el-input>
            <span>(kg)</span>
          </el-form-item>
          <el-form-item :label=shengjiang_12 prop="d1">
            <span class="first_span">d1</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.d1" auto-complete="off"></el-input>
            <span>(m)</span>
          </el-form-item>
          <el-form-item :label=shengjiang_5 prop="J">
            <span class="first_span">J</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.J" auto-complete="off"></el-input>
            <span>(Kgm^2)</span>
          </el-form-item>
          <el-form-item :label=shengjiang_6 prop="Tm">
            <span class="first_span">Tm</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.Tm" auto-complete="off"></el-input>
            <span>(Nm)</span>
          </el-form-item>
          <el-form-item :label=shengjiang_7>
            <el-radio-group style="padding-left:50px;" v-model="form.resource" @change="change">
              <el-radio :label=shengjiang_8></el-radio>
              <el-radio :label=shengjiang_9></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label=shengjiang_10 v-show="d2" prop="d2">
            <span class="first_span">d2</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.d2" auto-complete="off"></el-input>
            <span>(m)</span>
          </el-form-item>
          <el-form-item :label=shengjiang_11 v-show="d3" prop="d3">
            <span class="first_span">d3</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.d3" auto-complete="off"></el-input>
            <span>(m)</span>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane :label=Operationmode name="second">
        <el-form ref="form" :model="form" :rules="rules" label-width="150px" class="app_item_form">
          <el-form-item :label=zhuantai_12 prop="t1">
            <span class="first_span">t1</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t1" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_13 prop="t2">
            <span class="first_span">t2</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t2" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_14 prop="t3">
            <span class="first_span">t3</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t3" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_15 prop="t4">
            <span class="first_span">t4</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t4" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_16 prop="V">
            <span class="first_span">V</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.V" auto-complete="off"></el-input>
            <span>(m/min)</span>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <!-- 按钮 -->
    <div class="button_box">
      <span class="button" @click="renturnPrePage">{{$t('message.Return')}}</span>
      <span class="button" @click="toNextPage">{{$t('message.Next')}}</span>
    </div>
  </div>
</template>
<script>
  import {
    transLifter
  } from '@/store/electric_app'
  export default {
    name: 'SelectedLifter',
    data() {
      return {
        activeName: 'first',
        form: {
          m1:'',
          m2:'',
          m3:'',
          d1:'',
          J:'',
          Tm:'',
          t1:'',
          t2:'',
          t3:'',
          t4:'',
          V:'',
          d2:'',
          d3:'',
          resource:''
        },
        rules:{
          m1:[
            {required: true, message:'此项不能为空'},

          ],
          m2:[
            {required: true, message:'此项不能为空'},

          ],
          m3:[
            {required: true, message:'此项不能为空'},

          ],
          d1:[
            {required: true, message:'此项不能为空'},

          ],
          J:[
            {required: true, message:'此项不能为空'},

          ],
          Tm:[
            {required: true, message:'此项不能为空'},

          ],
          t1:[
            {required: true, message:'此项不能为空'},

          ],
          t2:[
            {required: true, message:'此项不能为空'},

          ],
          t3:[
            {required: true, message:'此项不能为空'},

          ],
          t4:[
            {required: true, message:'此项不能为空'},

          ],
          V:[
            {required: true, message:'此项不能为空'},

          ],
          d2:[

          ],
          d3:[

          ]
        },
        d2:false,
        d3:false,
        ApplicationSelection:this.$t('message.ApplicationSelection'),
        AppLoadconditions:this.$t('message.AppLoadconditions'),
        ReducerLoadconditions:this.$t('message.ReducerLoadconditions'),
        reducerSize:this.$t('message.reducerSize'),
        selectMotor:this.$t('message.selectMotor'),
        complete:this.$t('message.complete'),
        loadCondition:this.$t('message.loadCondition'),
        Operationmode:this.$t('message.Operationmode'),
        shengjiang_2:this.$t('message.shengjiang_2'),
        shengjiang_3:this.$t('message.shengjiang_3'),
        shengjiang_4:this.$t('message.shengjiang_4'),
        shengjiang_5:this.$t('message.shengjiang_5'),
        shengjiang_6:this.$t('message.shengjiang_6'),
        shengjiang_7:this.$t('message.shengjiang_7'),
        shengjiang_8:this.$t('message.shengjiang_8'),
        shengjiang_9:this.$t('message.shengjiang_9'),
        shengjiang_10:this.$t('message.shengjiang_10'),
        shengjiang_11:this.$t('message.shengjiang_11'),
        shengjiang_12:this.$t('message.shengjiang_12'),
        zhuantai_12:this.$t('message.zhuantai_12'),
        zhuantai_13:this.$t('message.zhuantai_13'),
        zhuantai_14:this.$t('message.zhuantai_14'),
        zhuantai_15:this.$t('message.zhuantai_15'),
        zhuantai_16:this.$t('message.zhuantai_16'),
      };
    },
    mounted(){
      var lang = localStorage.getItem('lang');
      if(lang == 'cn'){
        this.form.resource = '直接结合';
      }else if(lang == 'en'){
        this.form.resource = 'Direct coupling';
      }
    },
    methods: {
      toNextPage:function(){
        if(this.form.t1 == '' && this.form.t2 == '' && this.form.t3 == '' && this.form.t4 == '' && this.form.V == ''){
          this.$message({
            message: '请检查 减速机负载 与 运转模式 是否都已填写!!',
            type: 'warning'
          });
        }else{
          if(!this.form.d2){
            delete this.form.d2;
          }
          if(!this.form.d3){
            delete this.form.d3;
          }
          if(this.form.resource == '直接结合' || this.form.resource == 'Direct coupling'){
            delete this.form.d2;
            delete this.form.d3;
          }
          transLifter(this.form).then((response)=>{
            if(response.success === true){
              this.$emit("listenParam",response.data)
              this.$emit("listenPageChange","to_ReducerLoadPage")
              sessionStorage.setItem('childPageName','to_LifterPage')
            }else{
              this.$message({
                message: '升降机参数各项不能为空!',
                type: 'warning'
              });
            }
          })
        }
      },
      renturnPrePage:function(){
        this.$emit("listenPageChange","to_AppPage")
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      change(val) {
        if(val === '链轮' || val==='Sprocket'){
          this.d2 = true
          this.d3 = true
        }else{
          this.d2 = false
          this.d3 = false
        }
      }
    }
  };
</script>
<style scoped>
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
    padding-bottom:20px;
    background-image: url('../../../../static/load02.png');
    background-repeat:no-repeat;
    background-position-x:right 100px;
    background-position-y:510px;
  }
  @media screen and (-webkit-min-device-pixel-ratio:0){
    .content {
      width:100%;
      height: 100%;
      background: white;
      border-radius: 5px;
      box-shadow: 0 0 15px rgb(224, 224, 224);
      padding-bottom:20px;
      background-image: url('../../../../static/load02.png');
      background-repeat:no-repeat;
      background-position-x:90%;
      background-position-y:510px;
    }
  }
  .top {
    height:120px;
    border-bottom:1px solid #EBEBEB;
  }
  .el-steps-box {
    width:90%;
    margin:0 auto;
    padding-top:25px;
  }
  .el-steps {
    border-radius: 10px;
    background-color: #F5F7FA;
    background:url('../../../../static/step.png') no-repeat #F5F7FA;
    background-size:18% 100%;
    background-position-x:24%;
  }
  .el-tabs {
    width:66%;
    margin:0 auto;
    margin-top:50px;
  }
  .button {
    display: inline-block;
    width:97px;
    height:42px;
    background:#142479;
    color:#C6C6C6;
    text-align: center;
    line-height: 42px;
    border-radius: 10px;
    margin-left:15px;
    cursor: pointer;
  }
  .button_box {
    width:100%;
    text-align: center;
    padding-top:20px;
  }
  .app_item{
    margin-left:130px;
  }
  .app_item_form{
    margin-left:100px;
    margin-top:30px;
  }
  .app_item_form .el-input{
    width:60%;
    padding-left:30px;
  }
  .app_item_form .first_span{
    padding-left:50px;
    width:10px;
    display:inline-block;
  }
  .appPic {
    width:100%;
    margin:0 auto;
  }
  .appPic img {
    width:35%;
    height:35%;
    display:block;
    margin:0 auto;
    margin-top:20px;
  }
  .appPic_title {
    width:200px;
    margin:0 auto;
    text-align: center;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .app_item_form{
      margin-top:30px;
      margin-left:20px;
    }
    .app_item {
      margin-left:60px;
    }
    .content {
      width:100%;
      height: 100%;
      background: white;
      border-radius: 5px;
      box-shadow: 0 0 15px rgb(224, 224, 224);
      padding-bottom:20px;
      background-image: url('../../../../static/load02.png');
      background-repeat:no-repeat;
      background-position-x:right 60px;
      background-position-y:420px;
    }
    @media screen and (-webkit-min-device-pixel-ratio:0){
      .content {
        width:100%;
        height: 100%;
        background: white;
        border-radius: 5px;
        box-shadow: 0 0 15px rgb(224, 224, 224);
        padding-bottom:20px;
        background-image: url('../../../../static/load02.png');
        background-repeat:no-repeat;
        background-position-x:92%;
        background-position-y:420px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ApplicationSelection/SelectedAppLoad/SelectedLifter.vue